import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { ActivityActionsProps } from '../types';
import { AuthContext, AuthContextType } from 'src/contexts/AuthContext';
import { HistoryContext, HistoryContextType } from 'src/contexts/HistoryContext';
import { ActionMenuItem } from './ActionMenuItem';

export const QuickLogActions = ({ activity }: ActivityActionsProps) => {
  const {
    deleteQuickLogMutation: [executeDeleteQuickLog],
    showPopup
  } = useContext(HistoryContext) as HistoryContextType;

  const { activeMemberId } = React.useContext(AuthContext) as AuthContextType;

  const activitykeyUrlEncoded = encodeURIComponent(activity?.activitykey ?? 'null');

  const deleteQuickLog = () => {
    showPopup({
      title: 'Delete Quick Log',
      message: 'Are you sure you want to delete this Quick Log?',
      confirm: true,
      onConfirm: () => {
        if (!activity?.activitykey) {
          return;
        }
        executeDeleteQuickLog({
          variables: {
            memberid: activeMemberId,
            activitykey: activity.activitykey
          }
        });
      }
    });
  };

  return (
    <>
      <NavLink to={'/log/' + activitykeyUrlEncoded}>
        <ActionMenuItem icon={'edit'} title={'Edit'} />
      </NavLink>
      <ActionMenuItem onClick={deleteQuickLog} icon={'delete'} title={'Delete'} />
    </>
  );
};
